module.exports = __webpack_public_path__ + "media/images/Amsale-Nouvelle-Bridal-81cb0684.webp";